import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-report-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="card {{cardClass}}">
      <div class="card-body {{bodyClass}}">
        <div class="heading" *ngIf="heading">
          {{ heading }}
        </div>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: []
})
export class ReportCardComponent {
  @Input() heading?: string;
  @Input() cardClass = '';
  @Input() bodyClass = '';
}
